import { render, staticRenderFns } from "./UploadImageV3.vue?vue&type=template&id=0cd13fb2&scoped=true"
import script from "./UploadImageV3.vue?vue&type=script&lang=js"
export * from "./UploadImageV3.vue?vue&type=script&lang=js"
import style0 from "./UploadImageV3.vue?vue&type=style&index=0&id=0cd13fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd13fb2",
  null
  
)

export default component.exports